const template = `
	<div class="pie-chart">
		<div class="chart-inner">
			<highcharts
				:key="renderKey"
				v-if="data"
				:options="opts"
			></highcharts>
			<div v-else class="loading-label">{{ ii('LOADING') }}...</div>
		</div>
	</div>
`;

export default {
	template,
	props: ['title', 'data', 'tooltip-unit'],
	data() {
		return {
			renderKey: 0
		};
	},
	computed: {
		opts() {
			let v = this;

			let opts = {
				chart: {
					type: 'pie',
					spacingTop: 35,
					marginTop: 85,
					style: {
						fontFamily: 'Roboto, "Open Sans", sanf-serif, helvetica, tahoma, verdana'
					}
				},
				title: {
					text: this.title,
					style: {
						textTransform: 'uppercase',
						fontWeight: 500
					}
				},
				colors: ['#2f7ed8', '#0d233a', '#8bbc21', '#910000', '#1aadce', '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a'],
				tooltip: {
					hideDelay: 100,
					headerFormat: '',
					pointFormatter() {
						let val = v.util.numFormat(this.y);
						let percent = v.util.numFormat(this.percentage, '', 2);
						return `
							<span>
								<span style="color:${this.color}">●</span> ${this.name}
							</span>
							<br>
							<span>${v.tooltipUnit}: <b>${val}</b> (${percent}%)</span>
						`;
					}
				},
				legend: {
					align: 'center'
				},
				series: [{
					name: this.title,
					data: this.data
				}]
			};
			return opts;
		}
	},
	watch: {
		'app.lang'() {
			this.renderKey++;
		}
	}
}